import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';

const TimeoutModal = ({data, onVoucherApplied, mobile}) => {

  const [showModal, setShowModal] = useState(false);

  const {
    code,
    title,
    text,
    mobile_text,
    button_text,
    inactivity_delay,
    mouseout_delay,
    mobile_inactivity_delay,
    console_debug
  } = data;

  let getInactivityTimout = () => {
    return setTimeout(() => setShowModalType('inactivity'), inactivity_delay * 1000);
  }

  let getMouseoutTimout = () => {
    return setTimeout(() => setShowModalType('mouseout'), mouseout_delay * 1000);
  }

  let getMobileInactivityTimout = () => {
    return setTimeout(() => setShowModalType('inactivity mobile'), mobile_inactivity_delay * 1000);
  }

  let setShowModalType = (type) => {
    const codeApplied = sessionStorage.getItem('codeApplied');
    if (console_debug) {
      console.log('show timeout: ' + type);
      console.log('mobile: ' + mobile);
      console.log('codeApplied: ' + codeApplied);
      console.log('_________________');
    }
    if (!codeApplied) {
      setShowModal(true);
    }
  }
  let addEvent = (obj, evt, fn) => {
    if (obj.addEventListener) {
      obj.addEventListener(evt, fn, false);
    }
    else if (obj.attachEvent) {
      obj.attachEvent("on" + evt, fn);
    }
  }

  const handleApplyCode = () => {
    if (!mobile) {
      onVoucherApplied(code)
    } else {
      localStorage.setItem('inactivity-voucher-code', code);
      window.dispatchEvent(new Event("storage-inactivity-voucher-code"));
    }
    setShowModal(false);
    sessionStorage.setItem('codeApplied', code);
  }

  useEffect(
    () => {

      if (!mobile) {
        let inactivityTimeout = getInactivityTimout();
        document.onmousemove = () => {
          clearTimeout(inactivityTimeout);
          inactivityTimeout = getInactivityTimout();
        }

        window.document.body.addEventListener("keyup", (event) => {
          clearTimeout(inactivityTimeout);
          inactivityTimeout = getInactivityTimout();
        });

        let mouseoutTimeout = getMouseoutTimout();
        addEvent(document, "mouseout", function (e) {
          e = e ? e : window.event;
          let from = e.relatedTarget || e.toElement;
          if (!from || from.nodeName == "HTML") {
            clearTimeout(mouseoutTimeout);
            clearTimeout(inactivityTimeout);
            mouseoutTimeout = getMouseoutTimout();
          }
        });

        addEvent(document, "mouseover", function (e) {
          e = e ? e : window.event;
          let from = e.relatedTarget || e.toElement;
          if (from || from.nodeName != "HTML") {
            clearTimeout(mouseoutTimeout);
          }
        });
      } else {
        let mobileInactivityTimeout = getMobileInactivityTimout();
        window.document.body.addEventListener('touchstart', () => {
          clearTimeout(mobileInactivityTimeout);
          mobileInactivityTimeout = getMobileInactivityTimout();
        });

        window.document.body.addEventListener("keyup", (event) => {
          clearTimeout(mobileInactivityTimeout);
          mobileInactivityTimeout = getMobileInactivityTimout();
        });
      }

      return () => {};
    },

    []
  );

  const modalOverlayClassName = mobile ?
    'timeout-modal__overlay inactivity-timeout-modal__mobile' :
    'timeout-modal__overlay inactivity-timeout-modal';

  return (
    <Modal
      className='timeout-modal'
      isOpen={showModal}
      onRequestClose={() => setShowModal(false)}
      overlayClassName={modalOverlayClassName}
      shouldCloseOnOverlayClick={true}
    >
      <div>
        <div
          className="timeout-modal__close-button"
          onClick={() => setShowModal(false)}
        />
          <>
            <h2 className="timeout-modal__heading">
              {title}
            </h2>
            <p className="timeout-modal__description">
              {text}
            </p>
            <p className="timeout-modal__description-mobile">
              {mobile_text}
            </p>
            <button className="timeout-modal__apply-code-button" onClick={() => handleApplyCode()}>
              {button_text}
            </button>
          </>
      </div>
    </Modal>
  );
};


export default TimeoutModal;
